// OMS Quote Line Item Calculations
// Pure calculation functions with no DOM dependencies

import { TRANSACTION_TYPES } from '../utils/constants'
import { formatDate } from '../utils/formatters'

export class QuoteLineItemCalculations {
  // Extract data from a structured object (no DOM)
  static extractDataFromValues(values) {
    return {
      securityId: values.securityId,
      transactionType: values.transactionType || TRANSACTION_TYPES.BUY,
      quantity: values.quantity,
      price: values.price,
      yield: values.yield,
      margin: values.margin,
      spread: values.spread,
      inventoryMargin: values.inventoryMargin,
      marketMargin: values.marketMargin,
      settlementDate: values.settlementDate,
      parValuePricing: values.parValuePricing || 100,
      swapRate: values.swapRate,
      shortRate: values.shortRate
    }
  }
  
  // Format inventory data for display
  static formatInventoryData(inventoryMargin, inventoryPrice, inventoryFetchedAt) {
    return {
      marginDisplay: inventoryMargin !== null && inventoryMargin !== undefined 
        ? `${(inventoryMargin * 100).toFixed(3)}%` 
        : '-',
      priceDisplay: inventoryPrice !== null && inventoryPrice !== undefined && !isNaN(inventoryPrice)
        ? inventoryPrice.toFixed(3) 
        : '-',
      fetchedAtDisplay: inventoryFetchedAt 
        ? new Date(inventoryFetchedAt).toLocaleString()
        : 'Never'
    }
  }
}